module.exports = new __parcel__URL__("underwater_soundscape.a150d455.mp3").toString();